import axios from 'axios';
import { avicenna_api_root, xpertly_api_root } from './setup';

export function getAll() {
  return axios.get(`${avicenna_api_root}/tenants`);
}

export function create(data) {
  return axios.post(`${avicenna_api_root}/tenants/create`, data);
}

export function getById(id) {
  return axios.get(`${avicenna_api_root}/tenants/${id}`);
}

export function getUserById(tenant_id, user_id) {
  return axios.get(`${avicenna_api_root}/tenants/${tenant_id}/users/${user_id}`);
}

// export function getPublishableKey() {
//   return axios.get(`${xpertly_root}/tenants/billing/stripe-key`);
// }

export function createCheckoutSession(tenant_id, data) {
  return axios.post(`${xpertly_api_root}/tenants/${tenant_id}/billing/create-checkout-session`, data);
}

export function getCustomerPortal(tenant_id) {
  return axios.get(`${xpertly_api_root}/tenants/${tenant_id}/billing/customer-portal`);
}

export function request(tenant_id, form) {
  return axios.post(`${xpertly_api_root}/tenants/${tenant_id}/help/request`, form);
}